export default __webpack_public_path__ + "static/media/mobileHomeScreen.8d77f039.svg";